import React from 'react';

const IELTSUpsellContent: React.FC = (props) => {
  return (
    <ul className="u-padding-L-m">
      <li>Speaking, listening, reading, and writing</li>
      <li>Up to 10 practice tests</li>
      <li>120+ video lessons</li>
      <li>850+ practice questions</li>
      <li>Graded speaking assessments</li>
      <li>Graded writing assessments</li>
    </ul>
  );
};

export default IELTSUpsellContent;
